<template>
  <v-dialog v-model="dialog" width="1000px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="orange ml-2">{{ $t('tours.details') }}</v-btn>
    </template>
    <v-card class="elevation-12">
      <v-card-title class="headline orange font-weight-bold" primary-title>
        {{tourCourse.name}}
      </v-card-title>
          <v-row class="mr-0">
            <v-col class="pa-0">
                <v-carousel id="tourmodal-carousel" hide-delimiter-background show-arrows-on-hover v-for="(destination, i) in tourCourse.itinerary" v-if="selectedDestination == i">
                    <v-carousel-item v-for="(pic, j) in destination.pics"
                      :src="getImageURL(destination.folderName, pic)">
                    </v-carousel-item>
                </v-carousel>
            </v-col>
            <v-col class="pa-0" id="itinerary-picker">
                <v-card class="grey lighten-2 pa-3 font-weight-bold" justify-center>
                    {{ $t('tours.itinerary') }}
                </v-card>
                <v-card  v-for="(destination, i) in tourCourse.itinerary" class="pa-3" :class="[ i == selectedDestination ? 'orange' : '' ]" @click="selectDestination(i)">
                    {{ i+1 }}. {{ $t('tours.' + destination.folderName) }}
                </v-card>
            </v-col>
        </v-row>
      <div v-for="(destination, i) in tourCourse.itinerary" v-if="selectedDestination == i">
            <v-expansion-panels>
                <v-expansion-panel v-for="(value, property) in destination" v-if="value!=undefined && property!='name' && property!='picFolderName' && property!='pics' && property!='folderName'">
                  <v-expansion-panel-header>{{property.toUpperCase()}}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    {{value}}
                  </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        <v-divider></v-divider>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TourModal',
  props: ['tourCourse'],
  computed: {
    tourCourses() {
      return this.$store.getters.tourCourses;
    },
    filePath() {

      const folderName = this.$store.getters.tourCourses[0].course[0].picFolderName;
      const path = '../../../public/destinations/' + folderName;
      const number = '1';
      const file = number + '.jpg';
      const fullPath = path + '/' + file;
      const hello = '../../../public/gamcheonculturevillage/'+number+'.jpg';

      // return require('../../../public/gamcheonculturevillage/'+number+'.jpg')
      return require(hello);
    }
  },
  data: () => ({
    dialog: false,
    selectedDestination: 0,
    cool: 0

  }),
  methods: {
    selectDestination: function (index) {
      this.selectedDestination = index;
    },
    getImageURL: function (destination, pic) {
      return require('../../assets/destinations/' + destination + '/'+ pic)
    }
  }
};
</script>

<style scoped>
#tourmodal-carousel {
    width: 800px;
    display: inline-block;
}
/* #itinerary-picker {
    width: 200px;
    display: inline-block;
} */
</style>
